import React, { useState } from 'react'
import shortid from 'shortid'
import { Link } from 'gatsby'
import Modal from 'react-modal'
import ViewportPad from '../ViewportPad'
import LayoutCover from '../LayoutCover'
import Logo from '../Logo'

const Topbar = () => {
  // Ensure all IDs are unique throughout the site.
  const shortId = shortid.generate()
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <ViewportPad>
        <header className="vrst-topbar">
          <Logo wordmark />
          <nav aria-labelledby={`top-bar-${shortId}`}>
            <div id={`top-bar-${shortId}`} hidden>
              Primary Navigation
            </div>
            <ul>
              {!showModal && (
                <>
                  <li>
                    <Link to="/thesis">Thesis</Link>
                  </li>
                  <li>
                    <Link to="/writing">Writing</Link>
                  </li>
                  <li>
                    <Link to="/events">Events</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </>
              )}
              <li>
                <button onClick={() => setShowModal(!showModal)}>More +</button>
              </li>
            </ul>
          </nav>
        </header>
      </ViewportPad>
      <Modal
        isOpen={showModal}
        aria={{
          labelledby: `modal-title-${shortId}`,
        }}
        onRequestClose={() => setShowModal(false)}
        closeTimeoutMS={250}
        className="vrst-modal" // Used to remove default styles.
        overlayClassName="vrst-modal-overlay" // Used to remove default styles.
      >
        <ViewportPad>
          <LayoutCover>
            <div className="vrst-modal__top-bar">
              <Logo wordmark />
              <button onClick={() => setShowModal(!showModal)}>Close</button>
            </div>
            <h2 id={`modal-title-${shortId}`} hidden>
              Visit other pages
            </h2>
            <nav
              aria-labelledby={`services-nav-${shortId}`}
              data-position-center
            >
              <div id={`services-nav-${shortId}`} hidden>
                Services
              </div>
              <ul>
                <li>
                  <h3>
                    <Link to="/services/design-new-product">
                      Design a new product
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link to="/services/improve-existing-product">
                      Improve an existing product
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link to="/services/launch-new-company">
                      Launch a new company
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link to="/services/project-based-consulting">
                      Product consulting
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link to="/services/strategic-design">
                      Strategic design
                    </Link>
                  </h3>
                </li>
                <li>
                  <h3>
                    <Link to="/services/education-workshops">
                      Education &amp; workshops
                    </Link>
                  </h3>
                </li>
              </ul>
            </nav>
            <nav aria-labelledby={`secondary-nav-${shortId}`}>
              <div id={`secondary-nav-${shortId}`} hidden>
                Additional pages
              </div>
              <ul>
                <li>
                  <Link to="/thesis">Thesis</Link>
                </li>
                <li>
                  <Link to="/writing">Writing</Link>
                </li>
                <li>
                  <Link to="/events">Events</Link>
                </li>
                <li>
                  <Link to="/client-stories">Client Stories</Link>
                </li>
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
                <li>
                  <Link to="/code-of-values">Code of Values</Link>
                </li>
                <li>
                  <Link to="/diversity-and-inclusion/2019">
                    Diversity Report
                  </Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </nav>
          </LayoutCover>
        </ViewportPad>
      </Modal>
    </>
  )
}

export default Topbar
